import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../views/Home";
import Index from "../components/Index";
import SmartModule from "../components/SmartProduct/SmartModule/SmartModule";
import SmartHome from "../components/CaseShow/SmartHome";
import SmartEducation from "../components/CaseShow/SmartEducation";
import Librarian from "../components/CaseShow/Librarian";
import DownLoad from "../components/DownLoad";
import AboutUs from "../components/AboutUs";
import JingQingQiDai from "../components/JingQingQiDai";
import Gateway4G from "../components/SmartProduct/Gateway4G";
import Gateway5G from "../components/SmartProduct/Gateway5G";
import GatewayEthernet from "../components/SmartProduct/GatewayEthernet";
Vue.use(VueRouter)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    component: Home,
    redirect: '/index',
    children: [
      { path: '/index', component: Index },
      { path: '/smartmodule', component: SmartModule },
      { path: '/smarthome', component: SmartHome },
      { path: '/smarteducation', component: SmartEducation },
      { path: '/librarian', component: Librarian },
      { path: '/download', component: DownLoad },
      { path: '/mall', redirect: '/index',},
      { path: '/forum', redirect: '/index',},
      { path: '/aboutus', component: AboutUs },
      { path: '/5G', component: Gateway5G },
      { path: '/4G', component: Gateway4G },
      { path: '/ethernet', component: GatewayEthernet },

      // 没有完成的组件暂时显示为敬请期待
      { path: '/jingqingqidai',component: JingQingQiDai}
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
